import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  STATUS_CONFLICT,
  STATUS_FORBIDDEN
} from "../../../core/constants/const";
import { LOGOUT_TIMEOUT } from "../../../core/constants/consts";
import { ReservationResponseWs } from "../../../core/models/reservation.response.ws";
import { RoomListResponseWs } from "../../../core/models/room.list.response.ws";
import { RoomListWs } from "../../../core/models/room.list.ws";
import { RoomWs } from "../../../core/models/room.ws";
import { DateStringPipe } from "../../../shared/pipes/date.string.pipe";
import { MessagesPipe } from "../../../shared/pipes/messages.pipe";
import { AuthenticationService } from "../../../shared/services/authentication.service";
import { BaseService } from "../../../shared/services/base.service";
import { FlashMessagesService } from "../../../shared/services/flash-messages.service";
import { NavigatorRefreshService } from "../../../shared/services/navigator.refresh.service";
import { ReservationService } from "../../../shared/services/reservation.service";
import { RoomService } from "../../../shared/services/room.service";
import { WaitingService } from "../../../shared/services/waiting.service";
import { Utils } from "../../../shared/utils/utils";

@Component({
  templateUrl: "room.speed.available.component.html",
  styleUrls: ["room-available.scss"]
})
export class RoomSpeedAvailableComponent implements OnInit {
  roomList: RoomListWs;
  existAvailableRooms: boolean;
  availableRooms: RoomListResponseWs[];
  roomListResponseSelect: RoomListResponseWs;
  messagesPipe: MessagesPipe;
  reservationResponse: ReservationResponseWs;
  reservationBtnDisabled: boolean;
  showServerLunchMsg: boolean;
  roomDetail: RoomWs;

  constructor(
    private router: Router,
    private utils: Utils,
    private roomService: RoomService,
    private authenticationService: AuthenticationService,
    private flashMessagesService: FlashMessagesService,
    private baseService: BaseService,
    private navigatorRefreshService: NavigatorRefreshService,
    private reservationService: ReservationService,
    private waitingService: WaitingService
  ) {
    this.messagesPipe = new MessagesPipe();
    this.availableRooms = [];
    this.existAvailableRooms = true;
    this.roomListResponseSelect = new RoomListResponseWs();
    this.roomListResponseSelect.rooms = [];
    this.reservationBtnDisabled = false;
    this.reservationResponse = new ReservationResponseWs();
    this.showServerLunchMsg = false;
    this.roomDetail = new RoomWs("", "", "", "", "", false);
    this.roomDetail.reservations = [];
  }

  ngOnInit() {
    if (
      !this.authenticationService.getPermissionsForCurrentUser()
        .allowReservation
    ) {
      this.router.navigate(["/menu/home"]);
    }

    this.loadAvailableRooms();
    this.navigatorRefreshService.emitMenuRefreshLinkEvent(
      this.messagesPipe.transform("menu_available_rooms_speed")
    );
  }

  loadAvailableRooms() {
    if (localStorage.getItem("roomSpeedFilter")) {
      let actualDate = new Date();
      this.roomList = JSON.parse(localStorage.getItem("roomSpeedFilter"));
      this.roomList.dateFrom = new Date(this.roomList.dateFromInMillis);

      if (this.utils.compareDates(this.roomList.dateFrom, actualDate) < 0) {
        localStorage.removeItem("roomSpeedFilter");
        this.router.navigate(["/menu/home"]);
      } else {
        this.roomService
          .getSpeedAvailableRooms(
            this.roomList,
            this.authenticationService.getToken()
          )
          .subscribe(
            rooms => {
              this.availableRooms = rooms;

              if (this.availableRooms.length > 0) {
                this.roomListResponseSelect = this.availableRooms[0];
                this.existAvailableRooms = true;
              } else {
                if (this.roomList.periodicalDateTo) {
                  this.flashMessagesService.grayOut(false);
                  this.flashMessagesService.show(
                    this.messagesPipe.transform("periodicity_empty_rooms"),
                    { cssClass: "alert-sucess", timeout: 3000 }
                  );
                  this.router.navigate(["/menu/reservations"]);
                } else {
                  this.roomListResponseSelect = new RoomListResponseWs();
                  this.roomListResponseSelect.rooms = [];
                  this.existAvailableRooms = false;
                }
              }
            },
            error => {
              if (error.code == STATUS_FORBIDDEN) {
                this.authenticationService.refreshToken().subscribe(
                  response => {
                    this.loadAvailableRooms();
                  },
                  error => {
                    this.authenticationService.validateSessionId().subscribe(
                      response => {
                        this.loadAvailableRooms();
                      },
                      error => {
                        this.flashMessagesService.grayOut(false);
                        this.flashMessagesService.show(
                          this.messagesPipe.transform("error_forbidden"),
                          { cssClass: "alert-danger", timeout: 3000 }
                        );

                        setTimeout(() => {
                          this.authenticationService.logout();
                        }, LOGOUT_TIMEOUT);
                      }
                    );
                  }
                );
              } else {
                this.baseService.showErrorDialog(
                  this.flashMessagesService,
                  error,
                  this.messagesPipe.transform("available_rooms_list_error")
                );
                this.router.navigate(["/menu/home"]);
              }
            }
          );
      }
    } else {
      this.router.navigate(["/menu/home"]);
    }
  }

  changeBuilding(roomListResponse: RoomListResponseWs): void {
    this.closeRoomDetail();
    this.roomListResponseSelect = roomListResponse;
  }

  reserveRoom($event): void {
    let successMessage;
    this.reservationBtnDisabled = true;
    let roomWs = $event.room;

    if ($event.dateFrom) {
      this.roomList.dateFrom = $event.dateFrom;
      this.roomList.dateFromInMillis = this.roomList.dateFrom.getTime();
    }

    if ($event.duration) {
      this.roomList.duration = $event.duration;
    }

    this.reservationService
      .reservationSpeedBooking(
        roomWs,
        this.roomList,
        this.authenticationService.getToken()
      )
      .subscribe(
        response => {
          let dateStringPipe = new DateStringPipe();
          localStorage.removeItem("roomSpeedFilter");

          if (response.message != null && response.message.length > 0) {
            this.showServerLunchMsg = true;
            this.reservationResponse = response;
          } else {
            if (this.roomList.periodicalDateTo) {
              successMessage = this.messagesPipe.transform(
                "room_reserved_multiple_msg"
              );
            } else {
              successMessage = this.messagesPipe.transform(
                "room_speed_reserved_msg",
                [
                  roomWs.name,
                  dateStringPipe.transform(
                    this.roomList.dateFrom.toString(),
                    "DD/MM"
                  ),
                  dateStringPipe.transform(
                    this.roomList.dateFrom.toString(),
                    "HH:mm"
                  ),
                  this.roomList.duration
                ]
              );
            }

            this.flashMessagesService.grayOut(false);
            this.flashMessagesService.show(successMessage, {
              cssClass: "alert-success",
              timeout: 3000
            });

            this.router.navigate(["/menu/reservations"]);
          }
        },
        error => {
          if (error.code == STATUS_FORBIDDEN) {
            this.authenticationService.refreshToken().subscribe(
              response => {
                this.reserveRoom($event);
              },
              error => {
                this.authenticationService.validateSessionId().subscribe(
                  response => {
                    this.reserveRoom($event);
                  },
                  error => {
                    this.flashMessagesService.grayOut(false);
                    this.flashMessagesService.show(
                      this.messagesPipe.transform("error_forbidden"),
                      { cssClass: "alert-danger", timeout: 3000 }
                    );

                    setTimeout(() => {
                      this.authenticationService.logout();
                    }, LOGOUT_TIMEOUT);
                  }
                );
              }
            );
          } else {
            this.baseService.showErrorDialog(
              this.flashMessagesService,
              error,
              this.messagesPipe.transform("reserve_creation_error")
            );

            if (error.code == STATUS_CONFLICT) {
              localStorage.removeItem("roomSpeedFilter");
              this.router.navigate(["/menu/reservations"]);
            } else {
              this.router.navigate(["/menu/home"]);
            }
          }
        }
      );
  }

  showRoomDetail($event) {
    this.roomService
      .getRoomDetail(
        $event.id,
        this.roomList.dateFrom,
        this.authenticationService.getToken()
      )
      .subscribe(
        room => {
          if (typeof room.serverDate == "number") {
            room.serverDate = new Date(room.serverDate as number);
          }

          this.roomDetail = room;

          if (!this.roomDetail.reservations) {
            this.roomDetail.reservations = [];
          }
        },
        error => {
          if (error.code == STATUS_FORBIDDEN) {
            this.authenticationService.refreshToken().subscribe(
              response => {
                this.showRoomDetail($event);
              },
              error => {
                this.authenticationService.validateSessionId().subscribe(
                  response => {
                    this.showRoomDetail($event);
                  },
                  error => {
                    this.flashMessagesService.grayOut(false);
                    this.flashMessagesService.show(
                      this.messagesPipe.transform("error_forbidden"),
                      { cssClass: "alert-danger", timeout: 3000 }
                    );

                    setTimeout(() => {
                      this.authenticationService.logout();
                    }, LOGOUT_TIMEOUT);
                  }
                );
              }
            );
          } else {
            this.baseService.showErrorDialog(
              this.flashMessagesService,
              error,
              this.messagesPipe.transform("error_getRoomDetail")
            );
            this.router.navigate(["/menu/home"]);
          }
        }
      );
  }

  closeRoomDetail(): void {
    this.roomDetail = new RoomWs("", "", "", "", "");
    this.roomDetail.reservations = [];
  }

  addToWaitingList(): void {
    this.waitingService
      .waitingListSpeedAdd(this.roomList, this.authenticationService.getToken())
      .subscribe(
        response => {
          this.flashMessagesService.grayOut(false);
          this.flashMessagesService.show(
            this.messagesPipe.transform("room_to_waiting"),
            { cssClass: "alert-success", timeout: 3000 }
          );

          localStorage.removeItem("roomSpeedFilter");
          this.router.navigate(["/menu/reservations"]);
        },
        error => {
          if (error.code == STATUS_FORBIDDEN) {
            this.authenticationService.refreshToken().subscribe(
              response => {
                this.addToWaitingList();
              },
              error => {
                this.authenticationService.validateSessionId().subscribe(
                  response => {
                    this.addToWaitingList();
                  },
                  error => {
                    this.flashMessagesService.grayOut(false);
                    this.flashMessagesService.show(
                      this.messagesPipe.transform("error_forbidden"),
                      { cssClass: "alert-danger", timeout: 3000 }
                    );

                    setTimeout(() => {
                      this.authenticationService.logout();
                    }, LOGOUT_TIMEOUT);
                  }
                );
              }
            );
          } else {
            this.baseService.showErrorDialog(
              this.flashMessagesService,
              error,
              this.messagesPipe.transform("room_to_waiting_error")
            );

            if (error.code == STATUS_CONFLICT) {
              localStorage.removeItem("roomSpeedFilter");
              this.router.navigate(["/menu/reservations"]);
            } else {
              this.router.navigate(["/menu/home"]);
            }
          }
        }
      );
  }

  backToBookings(): void {
    this.router.navigate(["/menu/reservations"]);
  }
}
